import { Observable } from 'rxjs';
import { EventTypes } from '../../../../app/@store';
import { GetResponse } from '@vi-iot/client/models';

export type EventHistoryVersion = 'v1' | 'v2';

export interface EventsHistoryQueryParams {
  gatewaySerials: string;
  eventType?: string | string[];
  limit?: number;
  cursor?: string;
  timestamp?: string;
}

export interface EventsData {
  data: ViEvent[];
  cursor: { next: string };
}

export type ViEvent = ErrorEvent | NotificationEvent;

export interface ErrorEvent {
  eventType: EventTypes;
  gatewaySerial: string;
  createdAt: string;
  eventTimestamp: string;
  editedBy: string;
  body: {
    active: boolean;
    deviceId: string;
    modelId: string;
    errorCode: string;
    errorEventType: string;
    errorMessage: string;
    errorDescription: string;
    equipmentType: string;
  };
}

export interface NotificationEvent {
  eventType: EventTypes;
  gatewaySerial: string;
  createdAt: string;
  eventTimestamp: string;
  editedBy: string;
  body: {
    installationId?: number;
    gatewaySerial?: string;
    updateStatus?: string;
    online?: boolean;
    featureName?: string;
    boilerSerial?: string;
    bmuSerial?: string;
    deviceId?: string;
    editor?: string;
    modelId?: string;
    caller?: string;
    errorCode?: string;
    active?: boolean;
    inviter?: string;
    invitee?: string;
    savingPotentialAbsolute?: number;
    savingPotentialRelative?: number;
    temperatureRecommended?: number;
    temperatureCurrent?: number;
    durationRecommended?: number;
    durationCurrent?: number;
    startTime?: string;
    endTime?: string;
    commandName?: string;
    commandBody?: {
      mode?: string;
      temperature?: number;
      targetTemperature?: number;
      hysteresis?: number;
      actorDeviceId?: string;
      id?: string;
      name?: string;
      version?: string;
    };
    invitationStatus?: EventTypes.INVITATION_ACCEPTED | EventTypes.INVITATION_TERMINATED;
    firmwareVersion?:
      | {
          build: number;
          major: number;
          majorRevision: number;
          minor: number;
          minorRevision: number;
          revision: number;
        }
      | string;
  };
}

export interface EventHistoryApiModel {
  getEvents(
    installationId: string,
    params: EventsHistoryQueryParams,
    version: EventHistoryVersion
  ): Observable<EventsData>;

  triggerEventLogFileGeneration(installationId: number): Observable<GetResponse<string>>;

  downloadEventLogFile(installationId: number, processId: string): Observable<{ data: string }>;
}

export enum DeviceErrorMessageTypes {
  maintenance = 'P',
  warning = 'A',
  information = 'I',
  error = 'F',
  statusChanged = 'S',
}

export enum DTCDeviceNames {
  hems = 'hems',
}
